import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var ResponsiveService = /** @class */ (function () {
    function ResponsiveService() {
        this.currentBreakpointSubject = new BehaviorSubject(this.getCurrentBreakpoint(window.outerWidth));
        this.currentBreakpoint = this.currentBreakpointSubject.asObservable();
    }
    ResponsiveService.prototype.setCurrentBreakpoint = function (w) {
        this.currentBreakpointSubject.next(this.getCurrentBreakpoint(w));
    };
    ResponsiveService.prototype.getCurrentBreakpoint = function (w) {
        if (w < 576)
            return "xs";
        else if (w < 768)
            return "sm";
        else if (w < 992)
            return "md";
        else if (w < 1200)
            return "lg";
        else
            return "xl";
    };
    Object.defineProperty(ResponsiveService.prototype, "currentBreakpointValue", {
        get: function () {
            return this.currentBreakpointSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveService.prototype.isMobile = function () {
        return this.currentBreakpointSubject && this.currentBreakpointSubject.value && (this.currentBreakpointSubject.value == "xs" || this.currentBreakpointSubject.value == "sm");
    };
    ResponsiveService.ngInjectableDef = i0.defineInjectable({ factory: function ResponsiveService_Factory() { return new ResponsiveService(); }, token: ResponsiveService, providedIn: "root" });
    return ResponsiveService;
}());
export { ResponsiveService };
